import React, { ReactNode } from 'react';
import Header from './Header';
import { Layout, FloatButton } from 'antd';

interface layout {
  children: ReactNode;
}
const AppLayout: React.FC<layout> = ({ children }) => {
  const { Content } = Layout;


  return (
    <Layout className="layout">
       <Header/>
      <Content style={{ background: '#f9fcff' }}>{children}</Content>
      <FloatButton.BackTop />
    </Layout>
  );
};

export default AppLayout;
